import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ShopSection = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/assets/data/products.json")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.category === "office-printer" ||
            item.categories?.includes("office-printer")
        );
        setProducts(filtered);
      });
  }, []);

  const handleAddToCart = (product) => {
    const loggedIn = sessionStorage.getItem("isLoggedIn");

    if (loggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const exists = cart.find((i) => i.id === product.id);

    exists ? (exists.quantity += 1) : cart.push({ ...product, quantity: 1 });

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart`);
  };

  return (
    <section className="py-80" style={{ background: "#f8f9fb" }}>
      <div className="container container-lg">
        <div className="d-flex justify-content-between align-items-center mb-40">
          <h2 style={{ fontSize: "28px", fontWeight: 700, margin: 0 }}>
            Home Printers
          </h2>
          <span style={{ color: "#7a7a7a" }}>
            Showing {products.length} products
          </span>
        </div>

        <div className="row gy-4">
          {products.map((item) => {
            const shortDesc =
              item.description?.split(" ").slice(0, 12).join(" ") +
              (item.description?.split(" ").length > 12 ? "..." : "");

            const rating = (Math.random() * 1 + 4).toFixed(1);

            return (
              <div className="col-xl-3 col-lg-4 col-sm-6" key={item.id}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "18px",
                    padding: "18px",
                    cursor: "pointer",
                    transition: "0.3s",
                    border: "1px solid #eee",
                  }}
                  className="shop-card"
                >
                  {/* IMAGE */}
                  <Link
                    to={`/product/${item.id}`}
                    style={{ textAlign: "center" }}
                  >
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      style={{
                        width: "100%",
                        objectFit: "contain",
                        marginBottom: "18px",
                        transition: "0.3s",
                      }}
                      className="shop-img"
                    />
                  </Link>

                  {/* CATEGORY */}
                  <p
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      color: "#7f7f7f",
                      letterSpacing: "1px",
                      marginBottom: "6px",
                    }}
                  >
                    {item.category.replace(/-/g, " ")}
                  </p>

                  {/* NAME */}
                  <Link
                    to={`/product/${item.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        marginBottom: "8px",
                        color: "#111",
                      }}
                    >
                      {item.name}
                    </h4>
                  </Link>

                  {/* DESCRIPTION */}
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    {shortDesc}
                  </p>

                  {/* RATING */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      marginBottom: "12px",
                    }}
                  >
                    <i
                      className="ph-fill ph-star"
                      style={{ color: "#f7b500" }}
                    />
                    <span style={{ fontSize: "14px", fontWeight: 600 }}>
                      {rating}
                    </span>
                    <span style={{ color: "green", fontSize: "13px" }}>
                      • In Stock
                    </span>
                  </div>

                  {/* PRICE */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "18px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#111",
                      }}
                    >
                      ${item.price}
                    </span>
                  </div>

                  {/* BUTTON */}
                  <button
                    style={{
                      background: "#111",
                      color: "#fff",
                      width: "100%",
                      borderRadius: "10px",
                      padding: "12px 0",
                      fontWeight: 600,
                      border: "none",
                      transition: ".3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#000")}
                    onMouseLeave={(e) => (e.target.style.background = "#111")}
                    onClick={() => handleAddToCart(item)}
                  >
                    Add to Cart <i className="ph ph-shopping-cart ml-2"></i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ----------------- Styles ------------------ */

const headingStyle = {
  fontSize: "32px",
  fontWeight: 700,
  color: "#111",
};

const card = {
  background: "#fff",
  borderRadius: "22px",
  overflow: "hidden",
  position: "relative",
  boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
  transition: "0.3s",
  cursor: "pointer",
};

const wishlistBtn = {
  position: "absolute",
  top: 12,
  right: 12,
  border: "none",
  fontSize: "20px",
  background: "#fff",
  borderRadius: "50%",
  width: "36px",
  height: "36px",
  boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
  cursor: "pointer",
};

const imageBox = {
  padding: "25px",
  textAlign: "center",
};

const category = {
  fontSize: "11px",
  textTransform: "uppercase",
  letterSpacing: "1px",
  color: "#5e5e5e",
  marginBottom: "6px",
};

const title = {
  fontSize: "18px",
  fontWeight: 700,
  color: "#111",
  lineHeight: "1.3",
  marginBottom: "10px",
};

const titleLink = { textDecoration: "none" };

const ratingBox = {
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "14px",
  color: "#444",
};

const oldPrice = {
  textDecoration: "line-through",
  color: "#a1a1a1",
  marginRight: "6px",
};

const price = {
  fontSize: "22px",
  fontWeight: 800,
  color: "#111",
};

const cartBtn = {
  width: "100%",
  background: "#111",
  color: "#fff",
  padding: "12px",
  borderRadius: "10px",
  fontWeight: 600,
  border: "none",
  cursor: "pointer",
  transition: ".3s",
};

export default ShopSection;
